import { useState } from "react";
import { auth } from "../firebaseConfig";
import { sendPasswordResetEmail } from "firebase/auth";
import { Link } from "react-router-dom";
import AuthLayout from "../components/AuthLayout";
import toast from 'react-hot-toast';
import './Login.css'; // Reuse login styles

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await sendPasswordResetEmail(auth, email);
      setEmailSent(true);
      toast.success('Password reset email sent! Check your inbox.');
    } catch (error) {
      console.error("Password reset error:", error);
      
      // Handle specific Firebase auth errors
      let errorMessage = 'Failed to send password reset email';
      
      switch (error.code) {
        case 'auth/user-not-found':
          errorMessage = 'No account found with this email address.';
          break;
        case 'auth/invalid-email':
          errorMessage = 'Please enter a valid email address.';
          break;
        case 'auth/too-many-requests':
          errorMessage = 'Too many requests. Please try again later.';
          break;
        default:
          errorMessage = error.message || 'Failed to send password reset email';
      }
      
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  if (emailSent) {
    return (
      <AuthLayout title="Check your email">
        <div className="login-form">
          <div className="success-message">
            <h3>Password reset email sent!</h3>
            <p>We've sent a password reset link to <strong>{email}</strong></p>
            <p>Check your inbox and follow the instructions to reset your password.</p>
            <p>Didn't receive the email? Check your spam folder or try again with a different email address.</p>
          </div>
          <div className="login-links">
            <Link to="/login" className="login-link">Back to Login</Link>
          </div>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Reset your password">
      <form onSubmit={handleSubmit} className="login-form">
        <p className="login-message">
          Enter your email address and we'll send you a link to reset your password.
        </p>
        
        <div className="form-group">
          <input
            type="email"
            id="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="login-input"
          />
        </div>
        
        <button type="submit" className="login-button" disabled={loading || !email}>
          {loading ? 'Sending...' : 'Send Reset Email'}
        </button>
        
        <div className="login-links">
          <Link to="/login" className="login-link">Back to Login</Link>
          <span> • </span>
          <Link to="/signup" className="login-link">Create Account</Link>
        </div>
      </form>
    </AuthLayout>
  );
};

export default ForgotPassword; 